const API_URL: string | undefined = process.env.REACT_APP_BE_URL;

if (!API_URL) {
  throw new Error("REACT_APP_BE_URL is not defined");
}

export const loginEndpoints: string = `${API_URL}/slot/slot-game/user/login`;
export const demoLoginEndpoint: string = `${API_URL}/slot/slot-game/static/user/demo`;
export const registerEndpoint: string = `${API_URL}/slot/slot-game/static/user/signup`;
export const showUserHistoryEndPoint: string = `${API_URL}/slot/transaction/history`;
export const showLeaderBoardEndPoint: string = `${API_URL}/slot/slot-game/leaderboard/user`;
export const showOtherPerformersOnLeaderBoard: string = `${API_URL}/slot/slot-game/static/leaderboard/players`;
export const gameLaunchEndPoint: string = `${API_URL}/rgs-client/api/launch`;
